export default __webpack_public_path__ + "static/us-map-south-621b7445d37c43fcf8b4ef486c68fa06.svg";